import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';

function ToggleView(props) {

  const radios = [
    { name: '2D View', value: false },
    { name: '3D View', value: true },
  ];

  return (
      <ButtonGroup>
        {radios.map((radio, idx) => (
          <ToggleButton
            key={idx}
            id={`radio-${idx}`}
            type="radio"
            variant={idx % 2 ? 'outline-success' : 'outline-warning'}
            name="radio"
            value={radio.value}
            checked={props.radioValue === radio.value}
            onChange={props.handleChange}
          >
            {radio.name}
          </ToggleButton>
        ))}
      </ButtonGroup>
  );
}

export default ToggleView